export default function (data) {
  const self = this;
  self.$el = $('#student_listing');
  self.$invite_modal = $('#edit_role_modal');

  self.membership_types = ko.observableArray();
  self.status_filters = ko.observableArray();
  self.role_types = ko.observableArray();

  self.selected_membership_filter = ko.observable();
  self.selected_status_filter = ko.observable();
  self.selected_role_filter = ko.observable();
  self.search_query = ko.observable();

  self.students = ko.observableArray();
  self.paginator = ko.observable();
  self.total_count = ko.observable();
  self.selected_enrollment = ko.observable();
  self.selected_role = ko.observable();

  self.initUI = function() {
    self.bindPaginationEvents();

    $('#studentSearch').on('keypress', function(event) {
      const keycode = (event.keyCode ? event.keyCode : event.which);

      if (keycode == '13') {
        $('#studentSearch').blur();
        self.filterChanged();
      }
    });
  };

  self.bindData = function(data) {
    self.paginator(data.paginator);
    self.total_count(data.total_count);

    if (!data.refresh) {
      self.membership_types(data.membership_types);
      self.status_filters(data.status_filters);
      self.role_types(data.role_types.map((role) => I18n.t(`roles.${role.toLowerCase()}`)));
    }

    const mappedStudents = ko.mapping.fromJS(data.students);

    self.students(mappedStudents());
  };

  self.approveStudent = function(item) {
    const url = Kadenze.Routes.course_enroll_student_path(self.course_id, item.id());
    const method = 'POST';

    Kadenze.UIUtil.makeRequest(url, method, null, self.$el, null, function(data) {
      item.status('Approved');
      Kadenze.UIUtil.showNotice($('#notice_container'), data, 3000);
    }, function(xhr) {
      Kadenze.UIUtil.showNotice($('#notice_container'), xhr.responseJSON, 3000);
    });
  };

  self.lockStudent = function (item) {
    let status = item.status() == "approved" ? "locked" : "approved"
    let url = (item.status() == "approved" ? "course_update_status_path": "course_enroll_student_path")
    Kadenze.UIUtil.makeRequest(
      Kadenze.Routes[url](self.course_id, item.id()), "POST", null, self.$el, null, function (data) {
    item.status(status);
    Kadenze.UIUtil.showNotice($('#notice_container'), data, 3000);
    }, function (xhr) {
      Kadenze.UIUtil.showNotice($('#notice_container'), xhr.responseJSON, 3000);
    });
  };

  self.denyStudent = function(item, event) {
    self.removeStudent(item, event, 'deny');
  };

  self.deleteStudent = function(item, event) {
    self.removeStudent(item, event, 'delete');
  };

  self.uninviteStudent = function(item, event) {
    self.removeStudent(item, event, 'uninvite');
  };

  self.removeStudent = function(item, event, action) {
    const url = Kadenze.Routes.course_remove_student_path(self.course_id, item.id());
    const method = 'POST';
    const deletePrompt = 'Are you sure you want to ' + action + ' ' + item.full_name() + ' from this course?';

    Kadenze.UIUtil.confirmAction(deletePrompt, function() {
      const request = new Kadenze.AjaxRequest({
        url: url,
        method: method,
        loadingIndicator: {
          container: self.$el
        }
      });

      request.done(function() {
        self.studentListing(null, true, {refresh: true});
        new Kadenze.Notice.success({ message: data.message });
      });

      request.fail(function(xhr) {
        new Kadenze.Notice.error({ message: xhr.responseJSON.message });
      });
    });
  };

  self.studentListing = function(url, currentPage, query) {
    Kadenze.UIUtil.showLoadingIndicator(self.$el);

    //load the entries info from the server
    const page = currentPage ? $('.active.page').text().trim() : null;
    url = url ? url : Kadenze.Routes.course_students_path(self.course_id, _.extend({page: page}, query));

    const request = new Kadenze.AjaxRequest({
      url: url,
      type: 'GET',
      loadingIndicator: {
        container: self.$el
      }
    });

    request.done(function(data) {
      self.bindData(data);
    });

    request.fail(function(data) {
      console.warn('error retrieving coursework entry data');
      console.log(data);
    });

    request.always(self.bindPaginationEvents);
  };

  self.selectRole = function(item) {
    self.selected_enrollment(item);
    self.selected_role(item.role());
    self.$invite_modal.modal('show');
  };

  self.resetSelected = function() {
    self.selected_enrollment(null);
    self.selected_role(null);
  };

  this.getRoleName = item => {
    if (typeof item.enrollment_type === 'function') {
      return this.getEnrollmentTypeRole(item)
    } else {
      return this.getLocalizedRole(item)
    }
  };

  this.getLocalizedRole = item =>{
    if ( !Kadenze.isKadenze && item.role() === 'for_credit'){
      return I18n.t(`roles.paid_student`);
    } else {
      return I18n.t(`roles.${item.role()}`);
    }
  };

  this.getEnrollmentTypeRole = item => {
    return (item.enrollment_type().toLowerCase() != item.role()) ?
      item.role().replace('_', ' ').upcase() :
      item.enrollment_type();
  }

  self.changeRole = function() {
    self.$invite_modal.modal('hide');
    const url = Kadenze.Routes.student_change_role_path(self.selected_enrollment().id());
    const method = 'PATCH';
    const data = {role: self.selected_role(), enrollment_id: self.selected_enrollment().enrollment.id()};

    Kadenze.UIUtil.makeRequest(url, method, data, self.$el, null, function(data) {
      Kadenze.UIUtil.showNotice($('#notice_container'), data, 5000);
      self.selected_enrollment().role(self.selected_role());
      self.resetSelected();
    }, function(xhr) {
      Kadenze.UIUtil.showNotice($('#notice_container'), xhr.responseJSON, 5000);
    }, function() {
      $('.modal').modal('hide');
    });
  };

  self.initInviteCopyLinks = function() {
    let cb = new Clipboard('.js-invite-copy');
    cb.on('success', function() {
      new Kadenze.Notice.success({
        message: 'Invitation link copied to clipboard!'
      });
    });
  };

  self.bindPaginationEvents = function() {
    Kadenze.PaginationBinding.applyBindingsWithTextInput(self.studentListing.bind(self), $('.student-index__layout_col-full'));
  };


  self.filterChanged = function() {
    self.studentListing(null, false, {
      search: self.search_query(),
      membership: self.selected_membership_filter(),
      status: self.selected_status_filter(),
      role: (self.selected_role_filter() == 'Participant') ? 'Student' : self.selected_role_filter(),
      refresh: true
    });
  };

  self.selected_membership_filter.subscribe(self.filterChanged);
  self.selected_status_filter.subscribe(self.filterChanged);
  self.selected_role_filter.subscribe(self.filterChanged);

  const __construct = function(that) {
    that.course_id = $('#course_id').val();
    console.log('constructor called for CourseStudentListingViewModel');
    that.bindData(data);
    that.initInviteCopyLinks();
  }(this);
}

